// extracted by mini-css-extract-plugin
export default {"root":"loader_root__xd-7B","loader":"loader_loader__M-FUL"};